import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { JournalEntryType } from "../../types/journal";

interface JournalTabsProps {
    activeTab: JournalEntryType;
    setActiveTab: (tab: JournalEntryType) => void;
}

interface TabDefinition {
    id: JournalEntryType;
    icon: React.FC<{ className?: string }>;
}

export const JournalTabs: React.FC<JournalTabsProps> = ({ activeTab, setActiveTab }) => {
    const { t } = useTranslation();

    const tabs: TabDefinition[] = [
        { id: "morning", icon: Sun },
        { id: "evening", icon: Moon }
    ];

    return (
        <div className="flex space-x-2 sm:space-x-4">
            {tabs.map(({ id, icon: Icon }) => (
                <button
                    key={id}
                    onClick={() => setActiveTab(id)}
                    className={`flex-1 sm:flex-none flex items-center justify-center px-4 py-2.5 rounded-lg 
            transition-colors text-sm sm:text-base ${activeTab === id
                            ? id === "morning"
                                ? "bg-blue-50 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400"
                                : "bg-purple-50 dark:bg-purple-900/50 text-purple-600 dark:text-purple-400"
                            : "text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700"
                        }`}
                >
                    <Icon className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
                    {t(`journal.tabs.${id}`)}
                </button>
            ))}
        </div>
    );
};